import {h, Fragment} from "preact"
import { useProductFilters } from '@nosto/preact'
import { useEffect } from 'preact/hooks'

import { cleanValue } from "../helpers"

export default () => {
    const { filters, removeAll } = useProductFilters()

    const handleFilterRemove = (filter) => {
        filter.remove();
    };

    return filters.length > 0 && <div class="collection-selected-filters" aria-live="polite">
        {
            filters.map((filter) => {
                return <a href="javascript:void(0)" class="collection-selected-filters__item" onClick={(event) => {event.preventDefault; handleFilterRemove(filter)}}>
                    {cleanValue(filter.value)}
                </a>
            })
        }

        <a href="javascript:void(0)" class="link link--underline" onClick={(event) => {event.preventDefault; removeAll()}}>
            Clear all
        </a>
    </div>
}
